// eslint-disable-next-line import/prefer-default-export
export const STICKY_FOOTER_SLOT_ID = 'admin--footer-slot';
